import React, { Fragment } from "react";
import InstructorTable from "../../../components/InstructorsTable";

const Permission = () => {
  return (
    <Fragment>
      <div className="row page-titles">
        <div className="col-md-5 col-8 align-self-center">
          <h3 className="text-themecolor">Instrutores</h3>
        </div>
      </div>
      <div className="row">
        <div className="col-md-12">
          <div className="card">
            <InstructorTable />
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default Permission;
